<template>
    <div>
        <div class="flex justify-content-center">
            <div class="mt-4">
                <img class="image" alt="user header" src="layout/images/sebrae-transparente.png" style="width: 50%" />
            </div>
        </div>
        <div class="formgrid grid p-fluid justify-content-center mt-4" v-if="etapa == 'pesquisa'">
            <div class="field col-10 md:col-6 lg:col-4 xl:col-4">
                <h4>Informe o CPF do participante</h4>
                <InputText
                    v-if="modoTouchscreen"
                    :modelValue="cpfMascarado"
                    readonly
                    inputmode="none"
                    class="text-6xl"
                    ref="cpf"
                    @focus="mostrarTeclado = true"
                    @click="mostrarTeclado = true"
                />
                <InputMask
                    v-else
                    v-model="cpf"
                    mask="999.999.999-99"
                    :unmask="true"
                    class="text-6xl"
                    ref="cpf"
                    @keydown.enter="pesquisarParticipante()"
                />
                <small class="p-error" v-if="(v$.cpf.required.$invalid || v$.cpf.minLength.$invalid) && v$.cpf.$error"
                    >O CPF é obrigatório e deve ter 11 dígitos</small
                >
                <small class="p-error" v-if="v$.cpf.cpfValido.$invalid && !(v$.cpf.required.$invalid || v$.cpf.minLength.$invalid)">CPF inválido</small>
            </div>
        </div>
        <div class="flex justify-content-center" v-if="etapa == 'pesquisa'">
            <Button
                icon="pi pi-search"
                @click="pesquisarParticipante()"
                label="Buscar"
                title="Clique para verificar o participante"
                :disabled="isBuscarDisabled"
                class="mt-4 text-3xl"
            />
        </div>
        <TecladoVirtual
            v-if="mostrarTeclado && etapa === 'pesquisa' && modoTouchscreen"
            layout="numerico"
            @tecla="onTecla"
            @backspace="onBackspace"
            @limpar="onLimpar"
            @enter="pesquisarParticipante()"
            @fechar="mostrarTeclado = false"
        />
        <div v-if="etapa == 'qrcode' && participante">
            <div class="text-center card" style="width: 80%; max-width: 400px; margin: auto">
                <img width="300" height="300" :src="`data:image/PNG;base64,${participante.qrCode}`" alt="QrCode" />
                <hr />
                <div class="flex justify-content-center align-items-center">
                    <div style="margin: auto">
                        <h5>{{ participante.nome }}</h5>
                    </div>
                </div>
                <div class="flex align-items-center">
                    <div style="width: 50px">
                        <font-awesome-icon icon="envelope" size="lg" />
                    </div>
                    <div style="margin: auto">
                        <h5>{{ participante.email }}</h5>
                    </div>
                </div>
                <div class="flex align-items-center">
                    <div style="width: 50px">
                        <font-awesome-icon icon="phone" size="lg" />
                    </div>
                    <div style="margin: auto">
                        <h5>{{ participante.telefone }}</h5>
                    </div>
                </div>

                <div v-if="participante.corCordao" class="flex justify-content-center align-items-center mt-2">
                    <span
                        :style="{
                            backgroundColor: participante.corCordao,
                            width: '28px',
                            height: '28px',
                            borderRadius: '50%',
                            display: 'inline-block',
                            border: '1px solid #ccc',
                        }"
                    ></span>
                    <h5 class="ml-2 mb-0">{{ participante.nomeCorCordao || participante.classificacao }}</h5>
                </div>

                <div class="flex justify-content-center align-items-center">
                    <Button
                        icon="pi pi-print"
                        @click="emitirEtiqueta()"
                        label="Imprimir Local"
                        title="Clique para emitir a etiqueta"
                        class="mt-4 text-3xl mr-4"
                    />
                    <br />
                    <Button icon="pi pi-refresh" @click="reiniciar()" label="Nova Pesquisa" title="Clique para reiniciar a pesquisa" class="mt-4 text-3xl" />
                </div>
            </div>
        </div>
        <div v-if="etapa == 'formulario'">
            <credenciamento-form
                :cpfInformado="cpfLimpo"
                :participanteEncontrado="participante"
                :cpfSomenteLeitura="naoExibirFormularioNovoCredenciamento"
                @gerar-qrcode="gerarQrCode($event)"
                @reiniciar="reiniciar()"
            />
        </div>
        <div v-if="etapa == 'seguirCredenciamento'">
            <div class="text-center card" style="width: 80%; max-width: 500px; margin: auto">
                <Message :closable="false" severity="info">
                    Participante não encontrado. Por favor, dirija-se à área de credenciamento para realizar o credenciamento.
                </Message>
                <Button icon="pi pi-refresh" @click="reiniciar()" label="Nova Pesquisa" title="Clique para reiniciar a pesquisa" class="mt-4 text-3xl" />
            </div>
        </div>
        <div v-if="etapa == 'menorIdade'">
            <div class="text-center card" style="width: 80%; max-width: 500px; margin: auto">
                <Message :closable="false" severity="warn">
                    Participante menor de 18 anos, favor procurar funcionário do evento.
                </Message>
                <Button icon="pi pi-refresh" @click="reiniciar()" label="Voltar" title="Voltar para a digitação do CPF" class="mt-4 text-3xl" />
            </div>
        </div>
        <!-- Âncora usada para rolar até o fim da tela quando o formulário aparece (totem). -->
        <div ref="fundoCredenciamento"></div>
    </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { required, minLength } from '@vuelidate/validators';
import Servicos from './services.js';
import CredenciamentoForm from './CredenciamentoForm.vue';
import TecladoVirtual from '@/shared/components/TecladoVirtual.vue';
import { aplicarCaractere, aplicarBackspace } from '@/shared/libs/tecladoVirtual.js';
import imprimirEtiquetaHtml from '@/shared/libs/imprimirEtiquetaHtml.js';

export default {
    components: {
        CredenciamentoForm,
        TecladoVirtual,
    },

    setup() {
        return { v$: useVuelidate() };
    },

    data() {
        return {
            cpf: null,
            etapa: 'pesquisa',
            participante: null,
            naoExibirFormularioNovoCredenciamento: false,
            evento: {
                impressaoAutomatica: false,
            },
            mostrarTeclado: false,
            timerInatividade: null,
        };
    },

    validations() {
        return {
            cpf: {
                required,
                minLength: minLength(11),
                cpfValido: (value) => {
                    const cpfNumerico = value ? value.replace(/[^0-9]/g, '') : '';

                    if (!cpfNumerico || cpfNumerico.length !== 11) {
                        return false;
                    }
                    if (/^(\d)\1{10}$/.test(cpfNumerico)) {
                        return false;
                    }

                    return true;
                },
            },
        };
    },

    beforeCreate() {
        this.$store.dispatch('verificarVersao');
    },

    computed: {
        modoTouchscreen() {
            return this.$route.query.modo === 'touchscreen';
        },

        cpfLimpo() {
            if (!this.cpf) return '';
            return this.cpf.replace(/[^0-9]/g, '');
        },

        cpfMascarado() {
            return this.$toCpf(this.cpf || '');
        },

        isBuscarDisabled() {
            const cpfNumerico = this.cpfLimpo;

            if (!cpfNumerico || cpfNumerico.length !== 11) {
                return true;
            }

            if (/^(\d)\1{10}$/.test(cpfNumerico)) {
                return true;
            }

            return false;
        },
    },

    watch: {
        cpf: {
            handler() {
                if (this.v$ && this.v$.cpf) {
                    this.$nextTick(() => {
                        this.v$.cpf.$touch();
                    });
                }
            },
            immediate: false,
        },
    },

    methods: {

        onTecla(t) {
            this.cpf = aplicarCaractere(this.cpf || '', t, 11);
        },
        onBackspace() {
            this.cpf = aplicarBackspace(this.cpf || '');
        },
        onLimpar() {
            this.cpf = '';
        },

        rolarParaFundo() {
            // Só no totem: ao abrir o formulário (mais alto que a tela), rola sozinho
            // até o fim para revelar consentimento e botões, evitando scroll manual.
            if (!this.modoTouchscreen) return;
            this.$nextTick(() => {
                // Pequeno atraso para o CredenciamentoForm montar e preencher os campos
                // antes de medir a altura final da página.
                setTimeout(() => {
                    this.$refs.fundoCredenciamento?.scrollIntoView({ behavior: 'smooth', block: 'end' });
                }, 250);
            });
        },

        reiniciarTimerInatividade() {
            clearTimeout(this.timerInatividade);
            this.timerInatividade = setTimeout(() => {
                if (this.etapa !== 'pesquisa') this.reiniciar();
            }, 60000); // 60s sem interação → volta para a busca
        },

        pesquisarParticipante() {
            this.$store.dispatch('addRequest');
            const cpfParaPesquisa = this.cpfLimpo;
            Servicos.pesquisarParticipante(cpfParaPesquisa, this.$route.query.evento)
                .then((response) => {
                    if (response?.success) {
                        this.naoExibirFormularioNovoCredenciamento = !!response.data?.naoExibirFormularioNovoCredenciamento;
                        if (response.data?.seguirParaCredenciamento) {
                            // HU002 — flag "não apresentar formulário de novo credenciamento" ativa e CPF não encontrado
                            this.participante = null;
                            this.etapa = 'seguirCredenciamento';
                        } else if (response.data?.menorIdade) {
                            this.participante = null;
                            this.etapa = 'menorIdade';
                        } else {
                            this.participante = response.data;
                            this.etapa = 'formulario';
                        }
                    } else {
                        if (response?.falhaNaoMapeada) {
                            this.$toast.add({
                                severity: 'error',
                                summary: 'Pesquisa',
                                detail: response.errors[0],
                                life: 3000,
                            });
                        } else {
                            this.naoExibirFormularioNovoCredenciamento = false;
                            this.participante = { cpf: this.cpfLimpo };
                            this.etapa = 'formulario';
                        }
                    }
                    if (this.etapa === 'formulario') this.rolarParaFundo();
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest');
                    if (
                        this.evento?.impressaoAutomatica &&
                        this.participante?.cpf &&
                        this.participante?.nome &&
                        this.participante?.email &&
                        this.participante?.telefone
                    ) {
                        this.emitirEtiqueta();
                    }
                });
        },

        reiniciar() {
            this.etapa = 'pesquisa';
            this.participante = null;
            this.naoExibirFormularioNovoCredenciamento = false;
            this.cpf = null;
            this.mostrarTeclado = false;

            if (this.v$ && this.v$.cpf) {
                this.v$.cpf.$reset();
            }

            this.$nextTick(() => {
                if (this.$refs.cpf && this.$refs.cpf.$el) {
                    this.$refs.cpf.$el.focus();
                }
            });
        },

        emitirEtiqueta() {
            // Etiqueta renderizada em HTML no cliente (ver imprimirEtiquetaHtml.js):
            // não depende do PDF do backend nem do plugin de PDF do Chrome.
            // Tamanho ajustável por query param (larguraEtiqueta/alturaEtiqueta), sem mexer no código.
            imprimirEtiquetaHtml(this.participante, {
                largura: this.$route.query.larguraEtiqueta,
                altura: this.$route.query.alturaEtiqueta,
            });
            // Reset só depois que o job de impressão foi disparado.
            setTimeout(() => this.reiniciar(), 1500);
        },

        gerarQrCode(participante) {
            this.$store.dispatch('addRequest');
            Servicos.gerarQrCode(participante).then((response) => {
                if (response?.success) {
                    this.etapa = 'qrcode';
                    this.participante = response.data;
                } else {
                    this.etapa = 'formulario';
                }
                this.$store.dispatch('removeRequest');
            });
        },

        carregarEvento() {
            const eventoId = this.$route.query.evento;
            if (eventoId) {
                this.evento = {
                    id: eventoId,
                    impressaoAutomatica: false,
                };
            }
        },
    },

    mounted() {
        this.$store.dispatch('carregarConfigApp');
        this.carregarEvento();
        this.$refs.cpf.$el.focus();

        if (this.modoTouchscreen) {
            window.addEventListener('pointerdown', this.reiniciarTimerInatividade);
            window.addEventListener('keydown', this.reiniciarTimerInatividade);
            this.reiniciarTimerInatividade();
        }
    },

    updated() {
        if (this.etapa == 'pesquisa') {
            this.$refs.cpf.$el.focus();
        }
    },

    unmounted() {
        clearTimeout(this.timerInatividade);
        window.removeEventListener('pointerdown', this.reiniciarTimerInatividade);
        window.removeEventListener('keydown', this.reiniciarTimerInatividade);
    },
};
</script>

<style scoped>
.image {
    display: flex;
    margin: auto;
}
</style>
